import { useState } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { jsPDF } from 'jspdf';
import moment from 'moment';

import myFont from './fonts/CloisterBlack.ttf';
import imgChurch from './pics/kirche.jpg';
import imgLogo from './pics/logo.jpg';
import imgPlattler from './pics/plattler.jpg';

function generatePDF(doc, data, sortedParticipants) {
    
    const eventData = {
        title: data.startlist.title,
        date: moment.unix(data.startlist.date).format("DD.MM.YYYY"),
        location: data.startlist.location,
        version: data.startlist.version
    };

    renderCoverPage(doc, eventData);

    renderOverview(doc, eventData, data.startGroups, sortedParticipants);

    //console.log(data);
    //console.log(data.startGroups);
    /*
    for (let sgId = 1; sgId < 30; sgId++) {
        if (data.sgs.indexOf(sgId) !== -1) {
            renderStartGroup(doc, eventData, data.startGroups[data.sgs.indexOf(sgId)], sortedParticipants);
        }
    }
    */
    for (let i = 0; i < data.startGroups.length; i++) {
        let startGroup = data.startGroups[i];
        if (startGroup.id < 50) {
            renderStartGroup(doc, eventData, startGroup, sortedParticipants);
        }
    }

    insertFooters(doc, eventData);
}

function insertFooters(doc, eventData) {
    doc.setFont("times", "normal");
    doc.setFontSize(12);

    let pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.text(eventData.version, 15, 287, { align: "left" });
        doc.text(i + "/" + pageCount, 195, 287, { align: "right" });
    }
}

function renderCoverPage(doc, eventData) {
    //doc.line(0, 0, 210, 297);

    renderHeader(doc);

    let img = new Image();
    img.src = imgChurch;

    doc.addImage(img, "JPEG", 15, 60, 180, 210);

    doc.setFont("MyFont", "normal");
    doc.setFontSize(30);
    doc.text(eventData.title, 190, 75, { align: "right" });
    doc.text(eventData.date, 190, 89, { align: "right" });
    doc.text(eventData.location, 190, 103, { align: "right" });

    doc.setFontSize(45);
    doc.text("Startliste", 105, 245, { align: "center" });
    doc.setFontSize(24);
    doc.text("Einzel- und Gruppenwertung", 105, 257, { align: "center" });
}

function renderHeader(doc) {
    let plattler = new Image();
    plattler.src = imgPlattler;

    doc.addImage(plattler, 15, 10, 25, 25);

    let logo = new Image();
    logo.src = imgLogo;

    doc.addImage(logo, 170, 10, 25, 25);

    doc.setFont("MyFont", "normal");
    doc.setFontSize(18);
    doc.text("Bayerischer Inngau-Trachtenverband e.V.", 105, 20, { align: "center" });
    doc.text("Sitz Rosenheim - Gegründet 1903", 105, 28, { align: "center" });

    doc.setLineWidth(0.4);
    doc.line(53, 35, 157, 35);
}

function renderHeader2(doc, eventData) {
    doc.setFont("times", "bold");
    doc.setFontSize(16);
    doc.text("Startliste - " + eventData.title, 105, 50, { align: "center" });
    doc.text(eventData.location + " - " + eventData.date, 105, 58, { align: "center" });
}

function renderOverview(doc, eventData, startGroups, sortedParticipants) {
    doc.addPage();

    renderHeader(doc);
    renderHeader2(doc, eventData);

    doc.setFont("times", "bold");
    doc.setFontSize(16);
    doc.text("Veranstaltungsübersicht", 15, 75);

    let xg = 53;
    doc.setFontSize(12);
    doc.text("Startzeit", 15, 85);
    doc.text("Bühne", 35, 85);
    doc.text("Startgruppe", xg, 85);
    // GDD2024:
    doc.text("Teilnehmer", 163, 85);
    // previous:
    //doc.text("Teilnehmer", 138, 85);
    //doc.text("Plattler", 163, 85);

    doc.setFont("times", "normal");

    let y = 95;
    let incr = 7;

    const totCount = startGroups.reduce((totCount, startGroup) => {
        const count = startGroup.order ? startGroup.order.length : 0;
        const stage = startGroup.stage === 2 ? "Bühne II" : "Bühne I"
        doc.text(moment.unix(startGroup.time).format("HH:mm"), 29, y, { align: "right" });
        doc.text(stage, 35, y);
        doc.text(startGroup.name, xg, y);
        // GDD2024
        doc.text("" + (startGroup.id > 50 ? "" : count), 174, y, { align: "center" });
        // previous:
        //doc.text("" + (startGroup.id > 50 ? "" : count), 149, y, { align: "center" });
        //doc.text(startGroup.dance, 163, y);

        y += incr;
    
        return totCount + count;
    }, 0);

    doc.setLineWidth(0.2);
    // GDD2024:
    doc.line(167, y-5, 181, y-5);
    doc.text("" + totCount, 174, y, { align: "center" });
    // previous:
    //doc.line(142, y-5, 156, y-5);
    //doc.text("" + totCount, 149, y, { align: "center" });

    y += 10;

    doc.setFont("times", "bold");
    doc.setFontSize(12);
    doc.text("Teilnehmende Vereine", 15, y);

    y += 10;

    const yTop = y;
    const yIncr = 7;
    let x = 15;
    const xIncr = 45;

    doc.setFont("times", "normal");

    const associations = sortedParticipants.reduce((associations, startGroup) => {
        if (startGroup.list) {
            for (let i = 0; i < startGroup.list.length; i++) {
                if (startGroup.list[i].position) {
                    const association = startGroup.list[i].association;
                    if (associations.indexOf(association) === -1) {
                        associations.push(association);
                    }    
                }
            }
        }
        return associations;
    }, []).sort();

    for (let i = 0; i < associations.length; i++) {
        doc.text(associations[i], x, y);
        y += yIncr;
        if (y > 275) {
            x += xIncr;
            y = yTop;
        }
    }
}

function renderStartGroup(doc, eventData, sgData, sortedParticipants) {
    doc.addPage();

    renderHeader(doc);
    renderHeader2(doc, eventData);

    doc.setFont("times", "bold");
    doc.setFontSize(16);
    doc.text(sgData.name, 20, 75);

    doc.setFont("times", "normal");
    doc.setFontSize(12);
    doc.text("Plattler: " + sgData.dance, 20, 82);

    doc.setFont("times", "bold");
    doc.setFontSize(12);

    doc.text("Start-Nr.", 20, 93);
    doc.text("Name", 53, 93);
    doc.text("Verein", 125, 93);

    doc.setFont("times", "normal");
    doc.setFontSize(12);

    const participants = sortedParticipants.reduce((participants, participant) => {
        if (participant.sg === sgData.id) {
            participants = participant.list;
        }
        return participants;
    }, []);

    let y = 100;
    let incr = 7;
    participants.map(participant => {
        if (participant.position) {
            doc.text("" + participant.position, 27, y, { align: "center" });
            doc.text(participant.lastName + " " + participant.firstName, 53, y);
            doc.text(participant.association, 125, y);
        
            y += incr;    
        }
        if (y > 275) {
            y = 51;

            doc.addPage();

            renderHeader(doc);

            doc.setFont("times", "normal");
            doc.setFontSize(12);        
        }
        return null;
    });

}

async function clickHandler(filename, version, data, sortedParticipants) {
    
    const doc = new jsPDF();

    // load font
    await new Promise(async resolve => {
        const fontBlob = await (await fetch(myFont)).blob();

        const reader = new FileReader();
        reader.onload = function () {
            doc.addFileToVFS("MyFont.ttf", reader.result);
            doc.addFont("MyFont.ttf", "MyFont", "normal");
            resolve();
        };
        reader.readAsBinaryString(fontBlob);    
    });

    data.startlist.version = version; //moment().format("DD.MM.YYYY HH:mm:ss");

    // generate doc
    generatePDF(doc, data, sortedParticipants);

    if (!filename) {
        filename = "Startliste.pdf"
    }
    if (filename) {
        if (!filename.toLowerCase().endsWith(".pdf")) {
            filename += ".pdf"
        }
    }
    doc.save(filename);
}

function SLPDF(props) {

    const [ filename, setFilename ] = useState("Startliste.pdf");
    const [ modalVisibility, setModalVisibility ] = useState(false);
    const [ version, setVersion ] = useState("");

    function checkExport() {
        let complete = true;
        for (let i = 0; i < props.data.startGroups.length; i++) {
            let count = props.data.startGroups[i].count;
            const order = props.data.startGroups[i].order;
            let orderLength = 0;
            if (order && order.length) {
                orderLength = order.length;
            }
            if (count !== orderLength) {
                complete = false;
            }
        }

        if (complete) {
            startExport();
        }
        else {
            Modal.confirm({
                title: "Hinweis",
                content: (
                    <div style={{marginTop: 20}}>
                        <p>Es gibt noch Teilnehmer ohne Startnummer!</p>
                        <p>Startliste trotzdem exportieren?</p>
                    </div>
                ),
                cancelText: "Abbrechen",
                okText: "Ja",
                onOk: startExport
            });
        }
    }

    function startExport() {
        setVersion("Stand: " + moment().format("DD.MM.YYYY HH:mm:ss"));
        setModalVisibility(true);
    }
    
    return (
        <>
            <Button
                icon={<ExportOutlined/>}
                disabled={props.data.startGroups.length === 0}
                onClick={checkExport}
            >
                Exportieren (PDF)
            </Button>
            <Modal
                cancelText="Abbrechen"
                okText="Exportieren"
                onCancel={() => {
                    setModalVisibility(false);
                }}
                onOk={() => {
                    setModalVisibility(false);
                    clickHandler(filename, version, props.data, props.sortedParticipants);
                }}
                title="PDF-Startliste exportieren"
                visible={modalVisibility}
            >
                <Form
                    labelCol={{span:8}}
                    wrapperCol={{span:16}}
                >
                    <Form.Item
                        label="Dateiname"
                    >
                        <Input
                            allowClear={true}
                            onChange={event => setFilename(event.target.value)}
                            value={filename}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Versions-Text"
                    >
                        <Input
                            allowClear={true}
                            onChange={event => setVersion(event.target.value)}
                            value={version}
                        />
                    </Form.Item>
                </Form>
            </Modal>        
        </>
    );
}

export default SLPDF;